import Head from "next/head";
import styles from "./Slot2.module.css";

function DailyEventSchedule2({ data }) {
    const colorData = [
        {
          headingColor:
            "linear-gradient(0deg, rgba(255,177,27,1) 0%, rgba(254,208,53,1) 100%)",
          timeColor:
            "linear-gradient(227deg, rgba(204,142,22,1) 0%, rgba(203,166,42,1) 100%)",
          pointColor:
            "linear-gradient(270deg, rgba(255,177,27,1) 0%, rgba(254,208,53,1) 100%)",
          arrowColor: "15px solid #fcd73e",
        },
        {
          headingColor:
            "linear-gradient(0deg, rgba(71,64,144,1) 0%, rgba(97,81,156,1) 100%)",
          timeColor:
            "linear-gradient(227deg, rgba(71,64,144,1) 0%, rgba(97,81,156,1) 100%)",
          pointColor:
            "linear-gradient(270deg, rgba(71,64,144,1) 0%, rgba(97,81,156,1) 100%)",
          arrowColor: "15px solid #6452a4",
        },
        {
          headingColor:
            "linear-gradient(0deg, rgba(236,93,37,1) 0%, rgba(248,143,28,1) 100%)",
          timeColor:
            "linear-gradient(227deg, rgba(236,93,37,1) 0%, rgba(248,143,28,1) 100%)",
          pointColor:
            "linear-gradient(270deg, rgba(236,93,37,1) 0%, rgba(248,143,28,1) 100%)",
          arrowColor: "15px solid #f6961e",
        },
        {
          headingColor:
            "linear-gradient(0deg, rgba(4,143,174,1) 0%, rgba(0,167,203,1) 100%)",
          timeColor:
            "linear-gradient(227deg, rgba(4,143,174,1) 0%, rgba(0,167,203,1) 100%)",
          pointColor:
            "linear-gradient(270deg, rgba(4,143,174,1) 0%, rgba(0,167,203,1) 100%)",
          arrowColor: "15px solid #00abd6",
        },
        {
          headingColor:
            "linear-gradient(0deg, rgba(173,37,147,1) 0%, rgba(202,70,156,1) 100%)",
          timeColor:
            "linear-gradient(227deg, rgba(173,37,147,1) 0%, rgba(202,70,156,1) 100%)",
          pointColor:
            "linear-gradient(270deg, rgba(173,37,147,1) 0%, rgba(202,70,156,1) 100%)",
          arrowColor: "15px solid #d14292",
        },
        {
          headingColor:
            "linear-gradient(0deg, rgba(109,190,70,1) 0%, rgba(169,207,60,1) 100%)",
          timeColor:
            "linear-gradient(227deg, rgba(87,152,56,1) 0%, rgba(135,166,48,1) 100%)",
          pointColor:
            "linear-gradient(270deg, rgba(109,190,70,1) 0%, rgba(169,207,60,1) 100%)",
          arrowColor: "15px solid #b1d432",
        },
      ];

  return (
    <>
    <Head>
    <title>Daily Event Schedule And Agenda | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Event Schedule, Daily Agenda, Conference Program, Workshop Timeline, Seminar Schedule, Event Activities"
    ></meta>
    <meta
      property="og:title"
      content="Today's Full Event Schedule"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/daily_event_schedule_og_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="A modern daily event schedule timeline showing a full day of activities and sessions in colorful blocks against a dark background."
    ></meta>
    <meta
      property="og:description"
      content="View the full daily schedule for our event. Find details on all activities, sessions, and talks from start to finish. Plan your day with our detailed agenda."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/event-slots"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/daily_event_schedule_og_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="A modern daily event schedule timeline showing a full day of activities and sessions in colorful blocks against a dark background."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/event-slots"
    ></meta>
    <meta
      name="twitter:title"
      content="Today's Full Event Schedule"
    ></meta>
    <meta
      name="twitter:description"
      content="View the full daily schedule for our event. Find details on all activities, sessions, and talks from start to finish. Plan your day with our detailed agenda."
    ></meta>
    <link rel="canonical" href="https://www.divineinfinitebeing.com/event-slots" />
</Head>
      <div className={styles.eventslot_mainwrapper}>
        <div className={styles.common_width}>
          <div className={styles.eventslot_innerwrapper}>
            <h2 className={styles.eventslot_title}>DAILY EVENT SCHEDULE</h2>
            <div className={styles.eventslot_contentinnerwrapper}>
              {data.map((event, index) => {
                const colorIndex = index % colorData.length;
                const currentColor = colorData[colorIndex];
                return (
                  <div key={index} className={styles.eventslot_contentwrap}>
                    <div className={styles.eventslot_headingwrap}>
                      <div
                        className={styles.eventslot_headingtimesec}
                        style={{ background: currentColor.timeColor }}
                      >
                        <span>{event.startTime}</span>
                        <span>{event.endTime}</span>

                        <div
                          className={styles.eventslot_triangle}
                          style={{ borderRight: currentColor.arrowColor }}
                        ></div>
                        <div className={styles.eventslot_pointcirclewrap}>
                          <div
                            className={styles.eventslot_pointcircle_innerwrap}
                            style={{ background: currentColor.pointColor }}
                          ></div>
                        </div>
                      </div>
                      <h3
                        className={styles.eventslot_heading}
                        style={{ background: currentColor.headingColor }}
                      >
                        {event.title}
                      </h3>
                    </div>
                    <p className={styles.eventslot_content}>
                      {event.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DailyEventSchedule2;